import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import transactionApi from "@/api/transaction";
import scanSerialApi from "@/api/scanSerial";

const defaultState = () => ({
    mitra: {},
    transaction: {
        results: [],
        pagination: {}
    },
    transactionDetail: {},
    memberHasTransaction: [],
    pagination: {},
    messageResponse: ''

});

const state = defaultState();

const getters = {};

const mutations = {
    listMitra(state, data) {
        state.mitra = Object.assign({}, state.mitra, data);
    },
    listTransaction(state, data) {
        state.transaction = Object.assign({}, state.transaction, data);
    },
    listDetailTransaction(state, data) {
        state.transactionDetail = Object.assign({}, state.transactionDetail, data);
    },
    setMemberHasTransaction(state, data) {
        data.map(el => {
            el.member_text = `${el.member_network_mid} - ${el.member_name}`
            return el
        })
        state.memberHasTransaction = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = data;
    },
    saveMesageResponse(state, data) {
        state.messageResponse = data;
    }
};
const actions = {
    getMitra({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.cekMitra(params).then(({ data: { data } }) => {
            commit("listMitra", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getTransaction({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.dataTransaction().then(({ data: { data } }) => {
            commit("listTransaction", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getDetailTransaction({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.detailTransaction(param).then(({ data: { data } }) => {
            commit("listDetailTransaction", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getMemberHasTransaction({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.getMemberHasTransaction(param).then(({ data: { data } }) => {
            commit("setMemberHasTransaction", data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    submitTransactionMitra({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.transaksiMitra(value).then(res => {
            const data = res.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data.message;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        })
    },

    submitTransactionMitraBaru({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.transaksiMitraBaru(value).then(res => {
            const data = res.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data;
            commit("saveConfirmResponse", data.data);
            commit("saveMesageResponse", data.message);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    scanLinkSerial({ commit }, value) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            scanSerialApi.scanLinkSerial(value).then(res => {
                const data = res.data;
                commit("saveConfirmResponse", data);
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(data)
            }).catch(err => {
                const data = err.response.data;
                commit("saveConfirmResponse", data.data);
                commit("saveMesageResponse", data.message);
                commit(PROGRESS_FAIL, null, { root: true });
            })
        })
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};